import type { ErrorInfo, ReactNode } from "react";
import { Component } from "react";
import { getInterventionsAirbrake } from "../../utils/getInterventionsAirbrake";

export interface ErrorBoundaryProps {
  duid: string;
  site: string;
  children?: ReactNode;
}

interface ErrorBoundaryState {
  hasError: boolean;
}

export class ErrorBoundary extends Component<
  ErrorBoundaryProps,
  ErrorBoundaryState
> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    // If a downstream error is encountered, log it to Airbrake and render nothing on subsequent renders
    this.setState({ hasError: true });

    void getInterventionsAirbrake().notify({
      error: error.message,
      params: {
        source: "mobius-interventions",
        component: "ErrorBoundary",
        userId: this.props.duid,
        site: this.props.site,
        info: info,
        stackTrace: error.stack,
        componentStack: info.componentStack,
      },
    });
  }

  render() {
    return this.state.hasError ? null : this.props.children;
  }
}
